<template>
    <base-modal :value="value" @input="canceled"
        modal-classes="modal-danger"
        modal-content-classes="bg-gradient-danger"
    >
        <div class="py-3 text-center">
            <i class="tim-icons icon-t-warning icon-3x"></i>
            <h4 class="heading mt-4" v-if="!hideTitle">{{ definedTitle }}</h4>
            <h4 class="heading mt-4" v-else></h4>
            <slot></slot>
        </div>

        <template slot="footer">
            <div class="text-center">
                <base-button type="white" @click="confirmed">{{ $t('common.confirm') }}</base-button>
                <base-button type="link" class="text-white" @click="canceled">{{ $t('common.cancel') }}</base-button>
            </div>
        </template>
    </base-modal>
</template>

<script>
    export default {
        
        props: {
            value: {
                type: Object,
                required: true
            },
            title: {
                type: String,
                default: null
            },
            hideTitle: {
                type: Boolean,
                default: false
            },
        },

        computed: {
            definedTitle() {
                return this.title || this.$t('common.confirm-question')
            }
        },

        methods: {

            confirmed() {
                //$('#'+this.value.id).modal('hide')
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                    confirmed: true,
                    data: this.value.data
                })
            },
            canceled() {
                this.$emit('input', {
                    id: this.value.id,
                    show: false,
                    confirmed: false,
                    data: this.value.data
                })
            }
        }
    }
</script>